import { CreditCard } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Badge, ListRow, Money, Section } from "@/components/ui";
import { ratio } from "@/lib/money";
import { useCards } from "@/lib/queries";

interface Alert {
  key: string;
  card: string;
  label: string;
  used: string;
  limit: string;
  r: number;
}

/** Cards at ≥ 85 % of a personal usage limit (tope del periodo or uso máximo). Hidden when none. */
export function CardLimitAlerts() {
  const navigate = useNavigate();
  const { data: cards = [] } = useCards();
  const alerts: Alert[] = [];
  for (const { account, summary: s } of cards) {
    if (s.period_cap) {
      const r = ratio(s.por_pagar_periodo, s.period_cap);
      if (r >= 0.85)
        alerts.push({
          key: `${account.id}-cap`,
          card: account.name,
          label: "Tope",
          used: s.por_pagar_periodo,
          limit: s.period_cap,
          r,
        });
    }
    if (s.usage_target_amount) {
      const r = ratio(s.saldo_total, s.usage_target_amount);
      if (r >= 0.85)
        alerts.push({
          key: `${account.id}-use`,
          card: account.name,
          label: `Uso ${s.usage_target_pct}%`,
          used: s.saldo_total,
          limit: s.usage_target_amount,
          r,
        });
    }
  }
  if (alerts.length === 0) return null;
  alerts.sort((a, b) => b.r - a.r);
  return (
    <Section title="Límites de uso">
      {alerts.map((a) => (
        <ListRow
          key={a.key}
          onClick={() => navigate("/tarjetas")}
          leading={
            <CreditCard
              className={a.r > 1 ? "size-5 text-negative" : "size-5 text-warning"}
              aria-hidden
            />
          }
          title={a.card}
          subtitle={
            <>
              {a.label}: <Money value={a.used} compact /> / <Money value={a.limit} compact />
            </>
          }
          trailing={
            <Badge tone={a.r > 1 ? "negative" : "warning"}>
              {a.r > 1 ? "Excedido" : `${Math.round(a.r * 100)}%`}
            </Badge>
          }
        />
      ))}
    </Section>
  );
}
